import Head from "next/head";
import type {NextPage} from "next";
import dynamic from "next/dynamic";
import {handleLogout} from "components/utils"; import React from "react";

const WallBoard: NextPage = (props) => {

    const NoSSRExchangeViewComponent = dynamic(
        () => {
            return import("../components/entity/wallboard/wallboardFunc");
        },
        {ssr: false}
    );

    return (
        <div>
            <Head>
                <title>QMe - Live Wallboard</title>
                <meta name="description" content="QMe - Live Wallboard"/>
                <meta name="keywords" content="Live patient tracking software, opd management software, EMR software, EHR software"/>
                <meta name="robots" content="noindex, nofollow"/>
            </Head>
            <NoSSRExchangeViewComponent/>
        </div>
    );
};


export default WallBoard;
